import {Container, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {api} from "../../services/apiService";

import ProductOrOptionForm from "../../components/ProductOrOptionForm";


export default function OptionEdit() {
    const params = useParams();
    const navigate = useNavigate();
    // Récupération de l'ID du produit à modifier depuis l'URL
    const productId = params.id;
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        api.get(`/options/${productId}`)
            .then(response => {
                setInitialValues({
                    name: response.data.name,
                    description: response.data.description,
                    price: response.data.price,
                    isActive: response.data.active,
                    category: response.data.category.id,
                    tva: response.data.tva
                });
            })
            .catch(error => {
                console.error("Error fetching product data:", error);
                navigate("/options"); // Redirige vers la liste des produits en cas d'erreur
            });
    }, [productId, navigate]);

    const handleSubmit = (formData) => {
        return api.put(`/options/edit/${productId}`, formData)
            .then(() => {
                navigate("/options");
            })
            .catch(error => {
                console.error("Error updating product:", error);
            });
    };

    return (
        <Container>
            <Typography variant="h1" gutterBottom>Modifier une option</Typography>

            <ProductOrOptionForm onSubmit={handleSubmit} data={initialValues} editionMode={true}
                                 showDurationField={false}/>
        </Container>
    );
}
